export default "__VITE_PUBLIC_ASSET__030afd7b__"